import React from "react";
import { Description } from "@/erp_subpackage/components/YhBox/Description";
import useGlobalModel from "@/erp_subpackage/model/globalModel";
import { usePurchaseDrDetailsModel } from "./purchaseDrDetailsModel";
import { formatNum } from '@/erp_subpackage/utils/util';

export const FixedBottom = ({ modeKey, mode, rowCode, dispatch }) => {
    const { collapsed } = useGlobalModel(({ collapsed }) => [collapsed]);
    const { editDesc, addDesc, lookDesc } = usePurchaseDrDetailsModel();
    const typeDesc = {
        add: addDesc,
        edit: editDesc,
        look: lookDesc
    }

    const orderStatistics = [
        {
            label: "调拨数量",
            value: typeDesc[mode].numAll,
            color: "green",
            status: true
        },
        {
            label: "折前总计",
            value: typeDesc[mode].totalPreAmount,
            color: "green",
            status: true
        },
        {
            label: "调拨总计",
            value: formatNum(typeDesc[mode].actualAmount),
            color: "red",
            status: true
        }
    ]
    return (
        <div className="details-bot-fixed-warp" style={{ width: `calc(100% - ${collapsed ? '80px' : '200px'})`, paddingLeft: "43px" }}>
            {orderStatistics.map((item, index) => <Description key={index} {...item} />)}
        </div>
    )
}